import { supabase } from '@/integrations/supabase/client';
import { BaseAttachedResearch, EntityConfig } from '@/types/research-attachments';
import { buildSelectQuery } from '../utils/query-builders';

/**
 * Updates the summary for a research attachment
 */
export const updateSummary = async <T extends BaseAttachedResearch>(
  config: EntityConfig,
  attachmentId: string,
  summary: string
): Promise<T> => {
  // DISABLED: Workbook research system not implemented
  if (config.entityType === 'workbook') {
    console.log('[updateSummary] Workbook research disabled - operation not allowed');
    throw new Error('Workbook research system is currently disabled');
  }

  console.log(`[${config.entityType}UpdateSummary] ===== DATABASE UPDATE STARTING =====`);
  console.log(`[${config.entityType}UpdateSummary] Input parameters:`);
  console.log(`[${config.entityType}UpdateSummary] - attachmentId: ${attachmentId}`);
  console.log(`[${config.entityType}UpdateSummary] - summary length: ${summary.length}`);

  // First verify the attachment exists and belongs to the current user
  const { data: existingAttachment, error: checkError } = await supabase
    .from(config.tableName as any)
    .select('id, user_id, research_summary')
    .eq('id', attachmentId)
    .maybeSingle();

  if (checkError) {
    console.error(`[${config.entityType}UpdateSummary] Error checking attachment:`, checkError);
    throw checkError;
  }

  if (!existingAttachment) {
    console.error(`[${config.entityType}UpdateSummary] Attachment not found or access denied`);
    throw new Error(`${config.displayName} attachment not found or access denied`);
  }

  const selectQuery = buildSelectQuery(config);

  // Perform the update
  const { data, error } = await supabase
    .from(config.tableName as any)
    .update({ research_summary: summary })
    .eq('id', attachmentId)
    .select(selectQuery)
    .maybeSingle();

  if (error) {
    console.error(`[${config.entityType}UpdateSummary] Update error:`, error);
    throw error;
  }

  if (!data) {
    throw new Error(`Failed to update ${config.displayName.toLowerCase()} summary - no data returned`);
  }

  console.log(`[${config.entityType}UpdateSummary] ===== DATABASE UPDATE SUCCESSFUL =====`);

  return data as unknown as T;
};
